<template>
  <RxkDialog
    v-model="show"
    width="480"
    title="转交"
    :is-loading="loading"
    @sure="handleSure"
    @close="handleClose"
  >
    <div class="tw-p-[16px]">
      <el-form ref="formRef" :rules="rules" :model="formState" label-position="top">
        <el-form-item label="选择审批人" prop="operator">
          <MemberSingleSelection
            v-if="show"
            style="width: 100%"
            :data="memberCommonData"
            placeholder="选择成员"
            @sure="getOperator"
          />
        </el-form-item>
      </el-form>
    </div>
  </RxkDialog>
</template>
<script lang="ts" setup>
import { ref, computed, reactive, watch, nextTick } from 'vue'
import { RxkDialog } from '@/components/common/RxkDialog'
import { ComponentType, ComponentUseSceneType } from '@/enums/preObjectManage'
import { getComponentTree } from '@/apis/common'
import { AuthBtn } from '@/components/business/FlowDeal/config'

const props = defineProps({
  modelValue: Boolean,
  info: Object
})
const emit = defineEmits(['update:modelValue', 'submit'])

const show = computed({
  get: () => {
    return props.modelValue
  },
  set: (val: any) => {
    emit('update:modelValue', val)
  }
})

const loading = ref(true)

function handleClose() {
  emit('update:modelValue', false)
}

// form相关
watch(
  () => props.modelValue,
  val => {
    if (val) {
      nextTick(() => {
        if (!formRef.value) return
        formRef.value.resetFields()
        getMemberData()
      })
    }
  }
)
const formState = reactive({
  operator: ''
})
const formRef = ref()
const rules = {
  operator: [{ required: true, message: '请选择审批人', trigger: 'change' }]
}

async function handleSure(fn: Fn = () => {}) {
  if (!formRef.value) return
  await formRef.value.validate(async (valid: any) => {
    if (valid) {
      emit('submit', {
        action: AuthBtn.TRANSFER,
        assigner: formState.operator
      })
      handleClose()
      fn()
    } else {
      fn()
    }
  })
}

// 人员组件
const memberCommonData = ref<Recordable>()

const commonParams = {
  useSceneType: ComponentUseSceneType.paas,
  memberType: ComponentType.person
}

async function getMemberData() {
  const res = await getComponentTree({
    showResign: false,
    checkChildFlag: true,
    ...commonParams
  })
  memberCommonData.value = res
}

function getOperator(data: any) {
  const { userInfoList } = data
  if (userInfoList.length) {
    formState.operator = userInfoList[0].id
  } else {
    formState.operator = ''
  }
}
</script>
<style lang="scss" scoped></style>
